module.exports = __webpack_public_path__ + "img/velans1.1218f16.jpg";